import { createContext, useContext } from 'react';

export const CognitoLogoutContext = createContext<
  (() => Promise<void>) | null
>(null);

export function useCognitoLogout() {
  return useContext(CognitoLogoutContext);
}
